import React, { Component, createRef } from "react";
import Axios from "axios";
//remember, have to replace data-feather with font awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";
import daterangepicker from "daterangepicker"; // eslint-disable-line no-unused-vars
import moment from "moment";
import { Link } from "react-router-dom";

export class ExportInvoices extends Component {
  constructor(props) {
    super(props);
    this.DeleteModalCloseButton = createRef();
    // eslint-disable-next-line no-unused-vars
    this.dto = {
      order: [[4, "asc"]],
    };
    this.state = {
      invoices_ready_to_export: [],
      invoices_previously_exported: [],
      invoices: [],
      exports: [],
      start_date_range: moment().tz("America/Chicago").subtract(90, "d").format("MM/DD/YYYY"),
      end_date_range: moment().tz("America/Chicago").format("MM/DD/YYYY"),
      status_id: -1,
      qb_items_errors: [],
    };
  }
  componentDidMount() {
    $("#invoices-datatable").DataTable(this.dto);
    $("#exports-datatable").DataTable();
    this.GetInvoices();
    $("#daterange-selector").daterangepicker({ opens: "left" });
  }
  SubmitGetInvoices = () => {
    this.setState(
      {
        start_date_range: moment($("#daterange-selector").val().substr(0, $("#daterange-selector").val().indexOf(" -")))
          .tz("America/Chicago")
          .format("MM/DD/YYYY"),
      },
      (e) => {
        this.setState(
          {
            end_date_range: moment(
              $("#daterange-selector")
                .val()
                .substr($("#daterange-selector").val().indexOf(" - ") + 3),
            )
              .tz("America/Chicago")
              .format("MM/DD/YYYY"),
          },
          (e) => {
            this.GetInvoices();
          },
        );
      },
    );
  };
  GetInvoices = () => {
    const topThis = this;
    let dataObj = {
      "x-access-token": this.props.authToken,

      start_date: moment.utc(this.state.start_date_range).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      end_date: moment.utc(this.state.end_date_range).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      status_id: 2,
    };
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/invoices/get/all", dataObj)
      .then(function (response) {
        if (response["data"]["status"] === "Error") {
          topThis.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "Success") {
          if ($.fn.DataTable.isDataTable("#invoices-datatable")) $("#invoices-datatable").DataTable().destroy();
          topThis.setState({ invoices: response["data"]["data"] });
          topThis.setState(
            {
              invoices_ready_to_export: response["data"]["data"].filter((e) => {
                if (e.status === 2 && e.exported_at === null) return true;
                return false;
              }),
            },
            function () {
              $("#invoices-datatable").DataTable(topThis.dto);
            },
          );
          if ($.fn.DataTable.isDataTable("#exported-datatable")) $("#exported-datatable").DataTable().destroy();
          topThis.setState(
            {
              invoices_previously_exported: response["data"]["data"].filter((e) => {
                if (e.exported_at !== null) return true;
                return false;
              }),
            },
            function () {
              $("#exported-datatable").DataTable(topThis.dto);
            },
          );
        }
      })
      .catch(function (error) {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          topThis.props.setRelogRequired(true);
        }
        topThis.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(function () {});
  };
  AddInvoiceToExports = (e) => {
    let index = this.state.invoices.findIndex((x) => {
      return x.id === Number($(e.target).closest("button").attr("iid"));
    });
    let newState = this.state.invoices;
    newState[index]["disable"] = true;

    this.setState({
      invoices: newState,
    });
    $("#exports-datatable").DataTable().destroy();
    this.setState(
      (prevState) => ({ exports: [...prevState.exports, newState[index]] }),
      (e) => {
        $("#exports-datatable").DataTable();
      },
    );
  };
  RemoveInvoiceFromExports = (e) => {
    let index = this.state.exports.findIndex((x) => {
      return x.id === Number($(e.target).closest("button").attr("iid"));
    });
    let index2 = this.state.invoices.findIndex((x) => {
      return x.id === Number($(e.target).closest("button").attr("iid"));
    });
    let index3 = this.state.invoices_previously_exported.findIndex((x) => {
      return x.id === Number($(e.target).closest("button").attr("iid"));
    });
    console.log(Number($(e.target).closest("button").attr("iid")));
    let newState = this.state.exports;
    newState.splice(index, 1);
    $("#exports-datatable").DataTable().destroy();
    this.setState(
      {
        exports: newState,
      },
      (e) => {
        $("#exports-datatable").DataTable();
      },
    );
    let newState2 = this.state.invoices;
    newState2[index2]["disable"] = false;
    this.setState({
      invoices: newState2,
    });
    let newState3 = this.state.invoices_previously_exported;
    if (index3 !== -1) {
      newState3[index3]["disable"] = false;
      this.setState({
        invoices_previously_exported: newState3,
      });
    }
  };
  AddAllToExports = (e) => {
    //while add all implies all, it means all unexported and finalized invoices
    let newState = this.state.invoices;
    let newStateExports = this.state.exports;

    newStateExports = [
      ...newStateExports,
      ...newState.filter((i) => {
        return i.status === 2 && i.exported_at === null;
      }),
    ];

    newState = newState.map((i) => {
      if (i.status === 2 && i.exported_at === null) return { ...i, disable: true };
      return i;
    });
    this.setState({ invoices: newState });
    $("#exports-datatable").DataTable().destroy();
    this.setState({ exports: newStateExports }, (e) => {
      $("#exports-datatable").DataTable();
    });
  };
  AddBatchToExports = (e) => {
    //while add all implies all, it means all unexported and finalized invoices
    let newState = this.state.invoices_previously_exported;

    let newStateExports = this.state.exports;
    newStateExports = [
      ...newStateExports,
      ...newState.filter((i) => {
        return i.export_batches_xref === Number($(e.target).attr("ebid"));
      }),
    ];

    newState = newState.map((i) => {
      if (i.export_batches_xref === Number($(e.target).attr("ebid"))) return { ...i, disable: true };
      return i;
    });
    this.setState({ invoices_previously_exported: newState });
    $("#exports-datatable").DataTable().destroy();
    this.setState({ exports: newStateExports }, (e) => {
      $("#exports-datatable").DataTable();
    });
  };
  RemoveAllFromExports = () => {
    this.setState({
      invoices: this.state.invoices.map((x) => {
        return { ...x, disable: false };
      }),
    });
    this.setState({
      invoices_previously_exported: this.state.invoices_previously_exported.map((x) => {
        return { ...x, disable: false };
      }),
    });
    this.setState({
      invoices_ready_to_export: this.state.invoices_ready_to_export.map((x) => {
        return { ...x, disable: false };
      }),
    });
    $("#exports-datatable").DataTable().destroy();
    this.setState({ exports: [] }, (e) => {
      $("#exports-datatable").DataTable();
    });
  };

  GetExportFile = () => {
    const topThis = this;
    if (this.state.exports.length === 0) {
      topThis.props.MakeNotification("warning", "Please add invoices to export first.");
      return;
    }
    let dataObj = {
      "x-access-token": this.props.authToken,

      exports: this.state.exports,
    };
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/exports/invoices", dataObj)
      .then(function (response) {
        if (response["data"]["status"] === "Error") {
          topThis.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
          if (response["data"]["qberror"]) {
            topThis.setState({ qb_items_errors: response["data"]["data"] }, (e) => {
              window.$("#defaultModalDangerExplain").modal("show");
            });
          }
        }
        if (response["data"]["status"] === "Success") {
          let iifContent = "data:text/iif;charset=utf-8,";
          iifContent += response["data"]["data"];
          let encodedURI = encodeURI(iifContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedURI);
          let now = moment().format("MMDDYY");
          link.setAttribute("download", "InvoiceExport-EB" + response["data"]["batch_id"] + "-" + now + ".iif");
          document.body.appendChild(link); // Required for FF
          topThis.props.MakeNotification("success", "Export file successfully created.");
          link.click(); // This will download the data file
          $("#exports-datatable").DataTable().destroy();
          topThis.setState({ exports: [] }, (e) => {
            $("#exports-datatable").DataTable();
          });
          //window.open(encodedURI);
        }
      })
      .catch(function (error) {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          topThis.props.setRelogRequired(true);
        }
        topThis.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(function () {
        topThis.GetInvoices();
      });
  };
  render() {
    return (
      <main className="content">
        <div className="container-fluid">
          <div className="header">
            <h1 className="header-title">Export Invoices</h1>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header row">
                  <div className="card-actions float-end">
                    {/* <a href="#" className="me-1">
                      <FontAwesomeIcon icon="sync" id="clients-list-refresh" onClick={this.GetItems} />
                    </a>
                    <a href="#" className="me-1">
                      <FontAwesomeIcon icon="plus" id="clients-list-refresh" onClick={this.PrepAddItem} />
                    </a> */}
                  </div>
                  <div className="col-md-6">
                    <h5 className="card-title mb-0">Invoices Needing to Be Exported</h5>
                  </div>
                  <div className="col-md-6">
                    <h5 className="card-title mb-0">Export List</h5>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-1">
                    <div className="col-sm-12 col-md-6 col-lg-3">
                      <input className="form-control" type="text" id="daterange-selector" defaultValue={this.state.start_date_range + " - " + this.state.end_date_range} />
                    </div>
                    <div className="col-sm-12 col-md-1 col-xl-1">
                      <button id="timesheet-submit" className="btn btn-primary" onClick={this.SubmitGetInvoices}>
                        Submit
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-8">
                      <table id="invoices-datatable" className="table table-striped" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>Number</th>
                            <th>Client</th>
                            <th>Status</th>
                            <th>Date Invoiced</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.invoices_ready_to_export.map((e) => {
                            return (
                              <tr key={e.id}>
                                <td>
                                  <Link to={{ pathname: "/invoicing", state: { client_id: e.client_id, invoice_id: e.id } }}>
                                    <button className="btn btn-light" id={e.id}>
                                      #{e.name}
                                    </button>
                                  </Link>
                                </td>
                                <td>{e.client_name}</td>
                                <td>
                                  {e.status === 1 ? <span className="badge rounded-pill bg-primary">Proposed</span> : ""}
                                  {e.status === 2 ? <span className="badge rounded-pill bg-success">Finalized</span> : null}
                                </td>
                                <td>{this.props.MakeDateTimeReadable(e.invoiced_at)}</td>
                                <td>
                                  <Link to={{ pathname: "/invoicing", state: { client_id: e.clients_xref, invoice_id: e.id } }}>
                                    <button className="btn btn-primary">
                                      <FontAwesomeIcon icon="edit" />
                                    </button>
                                  </Link>
                                  &nbsp;
                                  <button className="btn btn-info" onClick={this.AddInvoiceToExports} iid={e.id} disabled={e.disable}>
                                    <FontAwesomeIcon icon="angle-double-right" />
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {/* button area */}
                      <div className=" mt-1">
                        <button className="btn btn-success" onClick={this.AddAllToExports}>
                          <FontAwesomeIcon icon="plus" />
                          &nbsp;Add All Invoices
                        </button>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-4">
                      <table id="exports-datatable" className="table table-striped" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>Number</th>
                            <th>Client</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* {this.state.invoices.length === 0 ? (
                            <tr className="text-center">
                              <th colSpan="7">No previous invoices</th>
                            </tr>
                          ) : null} */}
                          {this.state.exports.map((e) => {
                            return (
                              <tr key={e.id}>
                                <td>
                                  <Link to={{ pathname: "/invoicing", state: { client_id: e.client_id, invoice_id: e.id } }}>
                                    <button className="btn btn-light" id={e.id}>
                                      #{e.name}
                                    </button>
                                  </Link>
                                </td>
                                <td>{e.client_name}</td>
                                <td className="card-actions text-center">
                                  <Link to={{ pathname: "/invoicing", state: { client_id: e.clients_xref, invoice_id: e.id } }}>
                                    <button className="btn btn-primary">
                                      <FontAwesomeIcon icon="edit" />
                                    </button>
                                  </Link>
                                  &nbsp;
                                  <button className="btn btn-danger" iid={e.id} onClick={this.RemoveInvoiceFromExports}>
                                    <FontAwesomeIcon icon="angle-double-left" />
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div className="mt-1">
                        <div className="row">
                          <div className=" col-md-6">
                            <button className="btn btn-danger" onClick={this.RemoveAllFromExports}>
                              <FontAwesomeIcon icon="minus" />
                              &nbsp;Remove All Exports
                            </button>
                          </div>
                          <div className="text-end col-md-6">
                            <button className="btn btn-info" onClick={this.GetExportFile}>
                              <FontAwesomeIcon icon="file-export" />
                              &nbsp;Export!
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-header row">
                  <div className="card-actions float-end">
                    {/* <a href="#" className="me-1">
                      <FontAwesomeIcon icon="sync" id="clients-list-refresh" onClick={this.GetItems} />
                    </a>
                    <a href="#" className="me-1">
                      <FontAwesomeIcon icon="plus" id="clients-list-refresh" onClick={this.PrepAddItem} />
                    </a> */}
                  </div>
                  <div className="col-md-12 text-center">
                    <h5 className="card-title mb-0">Previously Exported Invoices</h5>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <table id="exported-datatable" className="table table-striped" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>Number</th>
                            <th>Client</th>
                            <th>Date Invoiced</th>
                            <th>Date Exported</th>
                            <th>Export Batch</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.invoices_previously_exported.map((e) => {
                            return (
                              <tr key={e.id}>
                                <td>
                                  <Link to={{ pathname: "/invoicing", state: { client_id: e.client_id, invoice_id: e.id } }}>
                                    <button className="btn btn-light" id={e.id}>
                                      #{e.name}
                                    </button>
                                  </Link>
                                </td>
                                <td>{e.client_name}</td>
                                <td>{this.props.MakeDateTimeReadable(e.invoiced_at)}</td>
                                <td>{this.props.MakeDateTimeReadable(e.exported_at)}</td>
                                <td>
                                  <button className="btn btn-light" ebid={e.export_batches_xref} onClick={this.AddBatchToExports}>
                                    #EB-{e.export_batches_xref}
                                  </button>
                                </td>
                                <td>
                                  <Link to={{ pathname: "/invoicing", state: { client_id: e.clients_xref, invoice_id: e.id } }}>
                                    <button className="btn btn-primary">
                                      <FontAwesomeIcon icon="edit" />
                                    </button>
                                  </Link>
                                  &nbsp;
                                  <button className="btn btn-info" onClick={this.AddInvoiceToExports} iid={e.id} disabled={e.disable}>
                                    <FontAwesomeIcon icon="angle-double-right" />
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* //----------------------------|Explain Why We Can't Export Modal|----------------------------\\ */}
          <div className="modal fade" id="defaultModalDangerExplain" tabIndex={-1} role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Unable to export this batch</h5>
                  <button type="button" id="user-delete-modal-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                </div>
                <div className="modal-body m-3">
                  <p className="mb-0 text-center">
                    <b>Exporting invoices requires that the invoice items all have the relevant QuickBooks information.</b>
                    <br></br>
                    <br></br>Please review the items below for the QuickBooks fields, and then try again.
                    <hr></hr>
                    {this.state.qb_items_errors.map((e) => {
                      return (
                        <div>
                          <b>{e.name}</b>
                        </div>
                      );
                    })}
                  </p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-info" data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default ExportInvoices;
